import React from 'react';

/**
 * ConfigEmptyState — an empty table is an invitation to act: say what is
 * (not) here and offer the next step. `action` is a node (usually a ToolbarButton).
 */
export default function ConfigEmptyState({ title, body, action }) {
  return (
    <div className="cp-empty" role="status">
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action || null}
    </div>
  );
}
